import { render, staticRenderFns } from "./BrandSelector.vue?vue&type=template&id=010d8528&scoped=true"
import script from "./BrandSelector.vue?vue&type=script&lang=js"
export * from "./BrandSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010d8528",
  null
  
)

export default component.exports